import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';

function UserForm({ bid, handleClose, handleUserData }) {

  const [userData, setUserData] = useState({
    email: '',
    password: '',
    displayName: '',
    claimConfig: {
      role: 'admin',
      bid: bid,
      businessProfile: false
    }
  });
  const [inputError, setInputError] = useState(null);

  function handleChange(event) {
    event.preventDefault();
    const { id, value } = event.target;
    setInputError(prevData => ({ ...prevData, [id]: '' }));
    setUserData(prevData => ({ ...prevData, [id]: value }));
  }

  const resetUserData = () => {
    setUserData({
      email: '',
      password: '',
      displayName: '',
      claimConfig: {
        role: 'admin',
        bid: bid,
        businessProfile: false
      }
    });
  }

  useEffect(() => {
    // //
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const { email, password, displayName, claimConfig } = userData;
    if (!displayName) {
      setInputError({ ...inputError, displayName: 'This field is required.' });
    } else if (!email) {
      setInputError({ ...inputError, email: 'This field is required.' });
    } else if (!password) {
      setInputError({ ...inputError, password: 'This field is required.' });
    } else if (!claimConfig) {
      setInputError({ ...inputError, claimConfig: 'This field is required.' });
    } else {
      handleUserData(userData);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className='mb-3'>
        <Form.Group controlId='displayName'>
          <Form.Label>User Name</Form.Label>
          <Form.Control
            placeholder='Alberto, Smith, Ellie etc.'
            onChange={handleChange}
            value={userData.displayName}
            className={inputError && inputError.displayName ? 'border-danger' : ''}
            isInvalid={inputError && inputError.displayName}
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.displayName}</Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='row mb-3'>
        <div className='col-md-6'>
          <Form.Group controlId='email'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type='email'
              placeholder='xyz@example.com'
              onChange={handleChange}
              value={userData.email}
              className={inputError && inputError.email ? 'border-danger' : ''}
              isInvalid={inputError && inputError.email}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.email}</Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className='col-md-6'>
          <Form.Group controlId='password'>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='XXXX-XXXX-XXXX'
              onChange={handleChange}
              value={userData.password}
              className={inputError && inputError.password ? 'border-danger' : ''}
              isInvalid={inputError && inputError.password}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.password}</Form.Control.Feedback>
          </Form.Group>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-between pt-3'>
        <Button
          variant="outline-danger"
          className='px-5 py-2'
          onClick={handleClose}
        >
          Close
        </Button>
        <Button
          variant="primary"
          className='px-5 py-2'
          type='submit'
        >
          Save
        </Button>
      </div>
    </Form>
  );
}

export default UserForm;
